// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner_spinner__59WW0","rotator":"spinner_rotator__lAJjR","path":"spinner_path__8vDmX","dash":"spinner_dash__vq82p"};